// Make :contains case insensitive
jQuery.expr[":"].contains = jQuery.expr.createPseudo( function( arg ) {

  return function( elem ) {
      return jQuery( elem ).text().toUpperCase().indexOf( arg.toUpperCase() ) >= 0;
  };

});